import { createContext } from 'react';

const MarkdownContext = createContext<{
    modules: object;
}>({ modules: {} });

export default MarkdownContext;
